module.exports = __webpack_public_path__ + "static/img/vacuum.2a3f7cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vacuum.png
// module id = R8g0
// module chunks = 1